import React from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Dialog,
} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const FormDialog = ({open, label, handleClose, handleSave, disabled, disabledReason, ...props}) => {

    return <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth className={"dialog"} maxWidth={"lg"}>
        <DialogTitle id="form-dialog-title" disableTypography>
            <h4 className={"dialog-title"}>{label}</h4>
        </DialogTitle>
        <DialogContent dividers>
            {props.children}
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>
                Close
            </Button>
            <Tooltip title={disabledReason || ""} arrow placement="top">
                <span>
                    <Button onClick={handleSave} className={"secondary"} disabled={!!disabled}>
                        Save Changes
                    </Button>
                </span>
            </Tooltip>
        </DialogActions>
    </Dialog>
}

export default FormDialog;